export default __webpack_public_path__ + "static/media/error_504.26a8496d.png";